import axios from 'axios';

const token = sessionStorage.getItem("simp-cli-token");

const api = axios.create({baseURL : 'https://sistemaimperium.com.br/simpcli',
// const api = axios.create({ baseURL: 'http://localhost:9500',   
  headers: { "Authorization": `Bearer ${token}` }
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        // Do something, call refreshToken() request for example;
        // return a request      

        if (token) {
          sessionStorage.removeItem("simp-cli-token");
          sessionStorage.removeItem("clientes");
          sessionStorage.removeItem("idcliente");
          sessionStorage.removeItem("idusuario");
        }
        window.location.reload();
        return api;
      }
      else {
        // if (error.response.status === ANOTHER_STATUS_CODE) {
        // Do something 
        return Promise.reject(error.response.data);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
